import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Химия. 8 класс",
        subject: "Топливо. Загрязнение воздуха, способы его предотвращения",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Топливо. Загрязнение воздуха, способы его предотвращения",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Заграничная Надежда Анатольевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории профильного образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>В ФОП ООО (2023) данная тема включена в содержание курсов химии как базового, так и углубленного уровней, и включает следующие дидактические элементы: Топливо. Использование угля и метана в качестве топлива. Загрязнение воздуха. Понятие о парниковом эффекте, о разрушении озонового слоя. </p>
                                </div>
                                <div style='padding: 2.4rem;'>На уроке в 8 классе обучающиеся впервые знакомятся с химическими особенностями процессов сжигания различных видов топлива. Экологические проблемы загрязнения атмосферы, связанные со сжиганием ископаемого топлива, впервые подробно освещены в основной образовательной программе по химии для основной школы. В то же время отбор современных и интересных для восьмиклассников примеров и ситуаций для раскрытия содержания урока, приближение учебного материала к жизненным интересам подростков – ещё не решенные задачи. Это может вызывать затруднения в работе учителя химии. </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Материалы данного кейса будут полезны учителю-предметнику как в определении содержания обучения на уроке, так и при организации учено-познавательной деятельности учеников в урочной и внеурочной работе. </div>
                                <div style='padding: 2.4rem; padding-top: 0; padding-bottom: 0'>
                                    <p>В составе материалов кейса:</p>
                                    <ul>
                                        <li>приведены актуальные примеры загрязнения атмосферы, обобщающие фактологический материал, с которым обучающиеся могли познакомиться при изучении географии, биологии, а также из сообщений СМИ и Интернета; </li>
                                        <li>предложены варианты организации учебно-познавательной деятельности учеников в зависимости от уровня подготовки, приёмы обобщения и закрепления знаний;</li>
                                        <li>включён дидактический материал (задания разной сложности) для школьников, который учитель может использовать как на уроке, так и для организации домашней работы;</li>
                                        <li>приведён текст статьи, в которой рассмотрены методические приёмы достижения результатов обучения по теме урока.</li>
                                    </ul>                         
                                </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Учебный материал урока служит основой для достижения таких результатов, как формирование естественно-научного мировоззрения и повышение уровня экологической культуры, понимание значения химической науки и технологии в жизни современного общества, развитие познавательной мотивации и интереса к обучению.</div>
                                `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Тема урока связана с актуальной проблемой современного мира – развитием энергетики, которая тесно переплетена с проблемами экологического состояния биосферы. В курсе химии в 8 классе обучающиеся впервые знакомятся с химической стороной процесса сжигания различных видов топлива. </p>
                        <p>Содержание урока включает в себя как известные школьникам сведения, так и новые понятия и ситуации, объединённые темой получения энергии. </p>
                        <p>Методы, используемые на уроке, зависят от подготовленности учеников к различным видам учебной деятельности. Это могут быть: частично поисковый метод или проблемное обучение. Учитель проводит занятие в соответствии с планом урока.</p>
                        <p>Для лучшего усвоения содержания урока учитель может эффективно использовать внутрипредметные и межпредметные связи, жизненный опыт и здравый смысл подростков.</p>`
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральный государственный образовательный стандарт основного общего образования. Приложение к приказу Министерства просвещения Российской Федерации от 21 мая 2021 года №287. URL: https://fgos.ru/fgos/fgos-ooo/  (Дата обращения: 04.03.2023)",
                "Примерная рабочая программа основного общего образования. Химия. Базовый уровень (для 8–9 классов образовательных организаций). – Москва: ИСРО РАО, 2021. Примерная рабочая программа основного общего образования предмета «Химия» базовый уровень (edsoo.ru)  URL: https://edsoo.ru/Primernie_rabochie_progra. (Дата обращения: 14.02.2023)",
                "Примерная рабочая программа основного общего образования. Химия. Углубленный уровень (для 8–9 классов образовательных организаций). – Москва: ИСРО РАО, 2022. Примерная рабочая программа основного общего образования предмета «Химия» углубленный уровень (edsoo.ru) URL: https://edsoo.ru/Primernie_rabochie_progra. (Дата обращения: 14.02.2023)",
                "Заграничная Н.А. Профессиональное саморазвитие учителя химии. Воспитательный потенциал курса химии как основа формирования личностных результатов обучения. 8–11 классы. Серия «Методическая лаборатория». – Волгоград: Учитель. – 2015",
                "Заграничная Н.А., Паршутина Л.А. Интеграция содержания и методов преподавания естественнонаучных предметов в школьном образовании / Н.А. Заграничная, Л.А. Паршутина // Педагогика. 2018, №9 ",
                "Ковалёва Г.С., Пентин А.Ю., Заграничная Н.А. и др. Естественно-научная грамотность: сборник эталонных заданий. Выпуск 2: учебное пособие для общеобразовательных организаций / [Г.С. Ковалёва, А.Ю. Пентин, Е.А. Заграничная Н.А. и др.]; под ред. Г.С. Ковалёвой, А.Ю. Пентина. – Москва; Санкт-Петербург: Просвещение, 2021. – 143с.: ил. — (Функциональная грамотность. Учимся для жизни)",
                "Савинкина Е.В., Логинова Г.П. Химия. Для школ и классов гуманитарного профиля: Учебник. 10 класс. – М: АСТ-ПРЕСС, 2001",
                "Единое содержание общего образования (edsoo.ru)",
                "Сайт ИСРО. Режим достyпа: https://skiv.instrao.ru",
                "Российская электронная школа (resh.edu.ru)"
            ],
            sites: [
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дидактический материал к уроку"
                },
                {
                    link: "./files/additional2.pdf",
                    fileName: "Методическая статья"
                }
            ]
        }
    ],
};
